__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "apw-root";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@material-ui/core", "4.12.4", () => (Promise.all([__webpack_require__.e(181), __webpack_require__.e(674), __webpack_require__.e(301), __webpack_require__.e(292), __webpack_require__.e(152), __webpack_require__.e(929), __webpack_require__.e(381), __webpack_require__.e(569), __webpack_require__.e(414), __webpack_require__.e(888), __webpack_require__.e(877), __webpack_require__.e(753), __webpack_require__.e(16), __webpack_require__.e(511), __webpack_require__.e(970), __webpack_require__.e(505)]).then(() => (() => (__webpack_require__(1726))))));
			register("@material-ui/lab", "4.0.0-alpha.58", () => (Promise.all([__webpack_require__.e(181), __webpack_require__.e(674), __webpack_require__.e(301), __webpack_require__.e(292), __webpack_require__.e(152), __webpack_require__.e(929), __webpack_require__.e(381), __webpack_require__.e(569), __webpack_require__.e(414), __webpack_require__.e(888), __webpack_require__.e(877), __webpack_require__.e(753), __webpack_require__.e(16), __webpack_require__.e(511), __webpack_require__.e(970), __webpack_require__.e(506), __webpack_require__.e(363)]).then(() => (() => (__webpack_require__(9794))))));
			register("apw-dynamic-bundle-reactjs", "0.4.1", () => (__webpack_require__.e(998).then(() => (() => (__webpack_require__(2998))))));
			register("clsx", "1.1.1", () => (__webpack_require__.e(53).then(() => (() => (__webpack_require__(53))))));
			register("dls-tokens", "1.46.0", () => (__webpack_require__.e(542).then(() => (() => (__webpack_require__(7646))))));
			register("history", "4.10.1", () => (Promise.all([__webpack_require__.e(730), __webpack_require__.e(988)]).then(() => (() => (__webpack_require__(3589))))));
			register("history", "4.10.1", () => (Promise.all([__webpack_require__.e(825), __webpack_require__.e(988)]).then(() => (() => (__webpack_require__(3794))))));
			register("react-dom", "17.0.2", () => (() => (__webpack_require__(961))), 1);
			register("react-error-boundary", "3.1.4", () => (__webpack_require__.e(740).then(() => (() => (__webpack_require__(4740))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(730), __webpack_require__.e(797), __webpack_require__.e(302), __webpack_require__.e(538)]).then(() => (() => (__webpack_require__(4625))))));
			register("react-router", "5.3.4", () => (Promise.all([__webpack_require__.e(825), __webpack_require__.e(549), __webpack_require__.e(271)]).then(() => (() => (__webpack_require__(6347))))));
			register("react-uuid", "2.0.0", () => (__webpack_require__.e(445).then(() => (() => (__webpack_require__(6445))))));
			register("react", "17.0.2", () => (() => (__webpack_require__(6540))), 1);
			initExternal(9899);
			initExternal(6650);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};